import { createFileRoute, redirect } from "@tanstack/react-router";

/** Moved to a tab on the agent's page; kept so old links still land. */
export const Route = createFileRoute("/_app/reviewer-learnings")({
  beforeLoad: () => {
    throw redirect({ to: "/agents/$slug/$tab", params: { slug: "reviewer", tab: "learnings" } });
  },
});
